import React from 'react';

const DashboardSkeleton: React.FC = () => {
  return (
    <div className="space-y-6 animate-pulse">
      {/* Metrics Overview Skeleton */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="bg-[#0F1629] rounded-xl p-4">
            <div className="h-4 bg-gray-700 rounded w-1/2 mb-2"></div>
            <div className="h-6 bg-gray-700 rounded w-1/4"></div>
          </div>
        ))}
      </div>

      {/* Risk Score and Asset Overview Skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-[#0F1629] rounded-xl p-6 h-48">
          <div className="h-4 bg-gray-700 rounded w-1/3 mb-4"></div>
          <div className="h-24 bg-gray-700 rounded"></div>
        </div>
        <div className="bg-[#0F1629] rounded-xl p-6 h-48">
          <div className="h-4 bg-gray-700 rounded w-1/3 mb-4"></div>
          <div className="h-24 bg-gray-700 rounded"></div>
        </div>
      </div>

      {/* Vulnerabilities and Assets Skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-[#0F1629] rounded-xl p-6">
          <div className="h-4 bg-gray-700 rounded w-1/3 mb-4"></div>
          <div className="space-y-2">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="h-12 bg-gray-700 rounded"></div>
            ))}
          </div>
        </div>
        <div className="bg-[#0F1629] rounded-xl p-6">
          <div className="h-4 bg-gray-700 rounded w-1/3 mb-4"></div>
          <div className="space-y-2">
            {[...Array(4)].map((_, index) => (
              <div key={index} className="h-12 bg-gray-700 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
